import React from 'react';
import { KeyRound, Users } from 'lucide-react';

function ApiKeyInput({ apiKey, onApiKeyChange, onLoadUsers, isLoading }) {
  return (
    <div className="mb-6 p-4 bg-slate-50 border border-slate-200 rounded-lg shadow-sm">
      <label htmlFor="apiKeyInput" className="block text-sm font-medium text-gray-700 mb-1">
        <KeyRound size={16} className="inline-block mr-2 text-gray-500" />
        Clé API Administrateur
      </label>
      <div className="mt-1 flex rounded-md shadow-sm">
        <input
          type="password"
          id="apiKeyInput"
          name="apiKey"
          value={apiKey}
          onChange={(e) => onApiKeyChange(e.target.value)}
          placeholder="Entrez votre clé API"
          className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300"
        />
        <button 
          type="button"
          onClick={onLoadUsers} 
          disabled={!apiKey || isLoading}
          className="inline-flex items-center px-4 py-2 border border-l-0 border-indigo-600 rounded-r-md bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Users size={16} className="mr-2" />
          Charger les utilisateurs
        </button>
      </div>
      {apiKey && <p className="mt-2 text-xs text-gray-500">La clé API est conservée localement pour cette session.</p>}
    </div>
  );
}

ApiKeyInput.defaultProps = {
  isLoading: false,
};

export default ApiKeyInput; 